<template>
  <div class="form-wrapper">
    <div class="form-wrapper-inner">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
// Layout-only wrapper. The `width` / `hide-logo` props of the Vue 2 version
// were declared but never read by the template or any caller.
</script>

<style scoped>
.form-wrapper {
  display: flex;
  justify-content: center;
  max-width: 100%;
  background-color: #fff;
}

.form-wrapper-inner {
  width: 100%;
}
</style>
